import { LineChart, LineChartProps } from '../../../renderers/line-chart/line-chart.component';
import { VENDING_PACKAGE_VOLUME_LINE_CHART_DEFINITION } from './vending-package-volume-line-chart.definition';
import { VENDING_PACKAGE_VOLUME_LINE_CHART_MOCK_DATA } from './vending-package-volume-line-chart.mock';

export const VendingPackageVolumeLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
    />
);

VendingPackageVolumeLineChart.definition = VENDING_PACKAGE_VOLUME_LINE_CHART_DEFINITION;
VendingPackageVolumeLineChart.mockData = VENDING_PACKAGE_VOLUME_LINE_CHART_MOCK_DATA;
